// extracted by mini-css-extract-plugin
module.exports = {"geoChart":"GeoChart__geoChart__hcnc3"};